import { useState, useEffect } from 'react';

export default function useViewportWidth() {
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    resetViewportWidth();
    window.addEventListener('resize', resetViewportWidth);
    return () => window.removeEventListener('resize', resetViewportWidth);
  }, []);
  const resetViewportWidth = () => {
    if (window.innerWidth >= 768) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  }
  return isDesktop;
}